export default __webpack_public_path__ + "static/media/admob-320x100.54a10380.png";